// extracted by mini-css-extract-plugin
module.exports = {"xs":"375px","sm":"600px","md":"834px","lg":"1280px","xl":"1280px","accordion":"Accordion-module__accordion___2Gw14","accordionHeader":"Accordion-module__accordionHeader___SrSCd"};